import React from "react";
import { Link } from "gatsby";
import LoginModal from "./LoginModal";

const rowClass = "flex min-h-[52px] w-full items-center justify-between border-b border-line text-lg font-medium text-ink";

/**
 * Menú desplegable de mobile: la misma navegación del escritorio más el acceso
 * de clientes (o el cierre de sesión) y la búsqueda.
 */
const MobileMenu = ({ isOpen, items, isAuthenticated, onSearchOpen, onLogout, onNavigate }) => {

	if (!isOpen) return null;

	return (
		<nav
			id="mobile-menu"
			className="absolute inset-x-0 top-full border-t border-line bg-white shadow-panel lg:hidden"
			aria-label="Menú móvil"
		>
			<div className="shell pb-8 pt-6">
				{
					items.map((item, index) => (
						<Link to={ item.href } key={ index } className={ rowClass } onClick={ onNavigate }>
							{ item.caption }
						</Link>
					))
				}

				<button type="button" className={ rowClass } onClick={ onSearchOpen }>
					Buscar <span aria-hidden="true">→</span>
				</button>

				<div className="h-7"></div>

				{
					isAuthenticated
						? (
							<button type="button" onClick={ onLogout } className={ `${rowClass} !text-[#8b2635]` }>
								Cerrar sesión
							</button>
						)
						: <LoginModal triggerClassName={ rowClass } />
				}
			</div>
		</nav>
	);
};

export default MobileMenu;
